module.exports = __webpack_public_path__ + "img/img_slide-2.b0751aa4.jpg";